/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * An interface for retrieving documents by URL that the compiler uses
 * to load templates.
 */
export class ResourceLoader {
    /**
     * @param {?} url
     * @return {?}
     */
    get(url) { return ''; }
}
//# sourceMappingURL=resource_loader.js.map